import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Resources from '@/components/Resources/Resources'
import Checklist from '@/components/Checklist/Checklist'

import PaSchools from '@/components/Schools/PaSchools.vue'
import PaSchoolsMain from '@/components/Schools/PaSchoolsMain'
import SchoolDetail from '@/components/Schools/SchoolDetail/SchoolDetail'

import PaSchoolFinder from '@/components/PaSchoolFinder/PaSchoolFinder.vue'

import Dashboard from '@/components/Dashboard/Dashboard'
import Summary from '@/components/Dashboard/Summary'

import ResourcesPage from '@/components/Dashboard/Resources.vue'

import SavedSchoolsMain from '@/components/Dashboard/SavedSchools/SavedSchoolsMain.vue'
import SavedSchools from '@/components/Dashboard/SavedSchools/SavedSchools'
import SavedSchoolInfo from '@/components/Dashboard/SavedSchools/SavedSchoolInfo.vue'

import GradesMain from '@/components/Dashboard/Grades/GradesMain'
import Grades from '@/components/Dashboard/Grades/Grades'
import ViewGradesDetail from '@/components/Dashboard/Grades/ViewGradesDetail'
import AddCollegeDialog from '@/components/Dashboard/Grades/Colleges/AddCollegeDialog'
import EditCollegeDialog from '@/components/Dashboard/Grades/Colleges/EditCollegeDialog'
import AddSemesterDialog from '@/components/Dashboard/Grades/Semesters/AddSemesterDialog'
import EditSemesterDialog from '@/components/Dashboard/Grades/Semesters/EditSemesterDialog'
import AddCourseDialog from '@/components/Dashboard/Grades/Courses/AddCourseDialog'
import AddCourseGradeDialog from '@/components/Dashboard/Grades/Courses/AddCourseGradeDialog'
import AddApCourse from '@/components/Dashboard/Grades/Apcourses/AddApCourse'
import AddClepCourse from '@/components/Dashboard/Grades/Clep/AddClepCourse'

import PaShadowingHours from '@/components/Dashboard/PaShadowingHours/PaShadowingHours'
import PaShadowingHoursMain from '@/components/Dashboard/PaShadowingHours/PaShadowingHoursMain'
import AddPaShadowing from '@/components/Dashboard/PaShadowingHours/AddPaShadowing'
import EditPaShadowing from '@/components/Dashboard/PaShadowingHours/EditPaShadowing'
import ViewPaShadowingHours from '@/components/Dashboard/PaShadowingHours/ViewPaShadowingHours'

import LogPaShadowingHours from '@/components/Dashboard/PaShadowingHours/PaShadowingHours/LogPaShadowingHours'
import EditPaShadowingHours from '@/components/Dashboard/PaShadowingHours/PaShadowingHours/EditPaShadowingHours'


import HealthcareHoursMain from '@/components/Dashboard/ExperienceHours/HealthcareHoursMain.vue'
import HealthcareHours from '@/components/Dashboard/ExperienceHours/HealthcareHours.vue'
import AddInstituition from '@/components/Dashboard/ExperienceHours/AddInstituition.vue'

import ViewDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/ViewDirectPaidHours.vue'
import LogDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/LogDirectPaidHours.vue'
import EditDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/EditDirectPaidHours.vue'
import EditLoggedDirectPaidHours from '@/components/Dashboard/ExperienceHours/DirectPaidHours/EditLoggedHours/EditLoggedDirectPaidHours.vue'


import ViewDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/ViewDirectHours.vue'
import LogDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/LogDirectHours.vue'
import EditDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/EditDirectHours.vue'
import EditLoggedDirectHours from '@/components/Dashboard/ExperienceHours/DirectHours/EditLoggedHours/EditLoggedDirectHours.vue'

import ViewIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/ViewIndirectHours.vue'
import LogIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/LogIndirectHours.vue'
import EditIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/EditIndirectHours.vue'
import EditLoggedIndirectHours from '@/components/Dashboard/ExperienceHours/IndirectHours/EditLoggedHours/EditLoggedIndirectHours.vue'

import ViewVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/ViewVolunteerHours.vue'
import LogVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/LogVolunteerHours.vue'
import EditVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/EditVolunteerHours.vue'
import EditLoggedVolunteerHours from '@/components/Dashboard/ExperienceHours/VolunteerHours/EditLoggedHours/EditLoggedVolunteerHours.vue'

import ViewCommunityServiceHours from '@/components/Dashboard/ExperienceHours/CommunityServiceHours/ViewCommunityServiceHours.vue'
import LogCommunityServiceHours from '@/components/Dashboard/ExperienceHours/CommunityServiceHours/LogCommunityServiceHours.vue'
import EditCommunityServiceInfo from '@/components/Dashboard/ExperienceHours/CommunityServiceHours/EditCommunityServiceInfo.vue'
import EditLoggedCommunityServiceHours from '@/components/Dashboard/ExperienceHours/CommunityServiceHours/EditLoggedHours/EditLoggedCommunityServiceHours.vue'

import AddCertification from '@/components/Dashboard/ExperienceHours/AddCertification.vue'
import EditCertification from '@/components/Dashboard/ExperienceHours/Certifications/EditCertification.vue'

import Evaluations from '@/components/Dashboard/Evaluations/Evaluations.vue'
import WriterInfo from '@/components/Dashboard/Evaluations/WriterInfo.vue'
import AddEvaluationWriter from '@/components/Dashboard/Evaluations/AddEvaluationWriter.vue'
import EditEvaluationWriter from '@/components/Dashboard/Evaluations/EditEvaluationWriter.vue'
import EvaluationsMain from '@/components/Dashboard/Evaluations/EvaluationsMain.vue'

import ExamsMain from '@/components/Dashboard/Exams/ExamsMain.vue'
import Exams from '@/components/Dashboard/Exams/Exams.vue'
import ExamInfo from '@/components/Dashboard/Exams/ExamInfo.vue'
import AddExam from '@/components/Dashboard/Exams/AddExam.vue'
import AddExamScores from '@/components/Dashboard/Exams/AddExamScores.vue'
import EditExam from '@/components/Dashboard/Exams/EditExam.vue'


// Users Components
import LoginSignupPage from '@/components/User/LoginSignupPage'
import Signup from '@/components/User/Signup'
import Account from '@/components/User/Account'
import Subscriptions from '@/components/User/Subscriptions'
import UserProfileQuestions from '@/components/User/UserProfileQuestions'


// Services Components
import ServicesBase from '@/components/Services/ServicesBase'
import Services from '@/components/Services/Services'
import ServiceDetails from '@/components/Services/ServiceDetails'
import ServicesPurchase from '@/components/Services/ServicesPurchase'
import ServicesPurchaseSuccess from '@/components/Services/ServicesPurchaseSuccess'
import ServicesPurchaseCancel from '@/components/Services/ServicesPurchaseCancel'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/checklist',
      name: 'Checklist',
      component: Checklist
    },
    {
      path: '/resources',
      name: 'Resources',
      component: Resources
    },
    { path: '/paschools', name: 'PaSchoolsMain', component: PaSchoolsMain,
      children: [
        {path:'', component: PaSchools, props: true },

      ]
    },
    {
      path: '/paschool/:id',
      name: 'SchoolDetail',
      props: true,
      component: SchoolDetail
    },

    {
      path: '/paschoolfinder',
      name: 'PaSchoolFinder',
      props: true,
      component: PaSchoolFinder
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard,
      children : [
        {path:'/', component: Summary, props: true },
        {path:'resources', name: 'resources', component: ResourcesPage, props: true },
        {path:'savedschools', name: 'SavedSchoolsMain', component: SavedSchoolsMain, props: true,
          children : [
            {path:'', component: SavedSchools, props: true },
            {path:'savedschoolinfo/:id', name: 'SavedSchoolInfo', props: true, component: SavedSchoolInfo},
          ]
        },
        {path:'mygrades', component: GradesMain, props: true,
          children : [
            {path:'', component: Grades, props: true },
            {path:'addcollege', component: AddCollegeDialog, props: true },
            {path:'editcollege/:id', component: EditCollegeDialog, props: true },
            {path: 'addsemester/:id', name: 'AddSemesterDialog', props: true, component: AddSemesterDialog},
            {path: ':collegeId/:semesterId/editsemester', name: 'EditSemesterDialog', props: true, component: EditSemesterDialog},
            {path: ':collegeId/:semesterId/addcourse', name: 'AddCourseDialog', props: true, component: AddCourseDialog},
            {path: ':collegeId/:semesterId/:courseId/addgrade', name: 'AddCourseGradeDialog', props: true, component: AddCourseGradeDialog},
            {path: 'mycollege/:id', name: 'ViewGradesDetail', props: true, component: ViewGradesDetail},
            {path:'addapcourse/:collegeId', name: 'AddApCourse',component: AddApCourse, props: true },
            {path:'addclepcourse/:collegeId', name: 'AddClepCourse',component: AddClepCourse, props: true },
          ]
        },

        {path:'pashadowing', component: PaShadowingHoursMain, props: true,
          children: [
            {path:'', component: PaShadowingHours, props: true },
            {path:'addpa', component: AddPaShadowing, props: true },
            {path:'editpashadow/:id', component: EditPaShadowing, props: true, component: EditPaShadowing },
            {path: 'pashadow/:id', name: 'ViewPaShadowingHours', props: true, component: ViewPaShadowingHours},
            {path: 'logpashadow/:id', name: 'LogPaShadowingHours ', props: true, component: LogPaShadowingHours },
            {path: 'editpashadowhours/:paShadowId/:loggedHourId', name: 'EditPaShadowingHours ', props: true, component: EditPaShadowingHours },
          ]
        },
        {path:'healthcarehours', component: HealthcareHoursMain, props: true,
          children: [
            {path:'', component: HealthcareHours, props: true },
            {path:'addexperience', component: AddInstituition, props: true },

            {path: 'directpaidexperience/:id', name: 'ViewDirectPaidHours', props: true, component: ViewDirectPaidHours},
            {path: 'logdirectpaidexperience/:id', name: 'LogDirectPaidHours', props: true, component: LogDirectPaidHours},
            {path: 'editdirectpaidexperience/:id', name: 'EditDirectPaidHours', props: true, component: EditDirectPaidHours},
            {path: 'editdirectpaidhours/:directPaidHoursInfoId/:loggedHourId', name: 'EditLoggedDirectPaidHours', props: true, component: EditLoggedDirectPaidHours},

            {path: 'directexperience/:id', name: 'ViewDirectHours', props: true, component: ViewDirectHours},
            {path: 'logdirectexperience/:id', name: 'LogDirectHours', props: true, component: LogDirectHours},
            {path: 'editdirectexperience/:id', name: 'EditDirectHours', props: true, component: EditDirectHours},
            {path: 'editdirecthours/:directHoursInfoId/:loggedHourId', name: 'EditLoggedDirectHours', props: true, component: EditLoggedDirectHours},

            {path: 'indirectexperience/:id', name: 'ViewIndirectHours', props: true, component: ViewIndirectHours},
            {path: 'logindirectexperience/:id', name: 'LogIndirectHours', props: true, component: LogIndirectHours},
            {path: 'editindirectexperience/:id', name: 'EditIndirectHours', props: true, component: EditIndirectHours},
            {path: 'editindirecthours/:indirectHoursInfoId/:loggedHourId', name: 'EditLoggedIndirectHours', props: true, component: EditLoggedIndirectHours},

            {path: 'volunteerexperience/:id', name: 'ViewVolunteerHours', props: true, component: ViewVolunteerHours},
            {path: 'logvolunteerexperience/:id', name: 'LogVolunteerHours', props: true, component: LogVolunteerHours},
            {path: 'editvolunteerexperience/:id', name: 'EditVolunteerHours', props: true, component: EditVolunteerHours},
            {path: 'editvolunteerhours/:volunteerHoursInfoId/:loggedHourId', name: 'EditLoggedVolunteerHours', props: true, component: EditLoggedVolunteerHours},

            {path: 'communityserviceexperience/:id', name: 'ViewCommunityServiceHours', props: true, component: ViewCommunityServiceHours},
            {path: 'logcommunityserviceexperience/:id', name: 'LogCommunityServiceHours', props: true, component: LogCommunityServiceHours},
            {path: 'editcommunityserviceexperience/:id', name: 'EditCommunityServiceInfo', props: true, component: EditCommunityServiceInfo},
            {path: 'editloggedcommunityservicehours/:communityServiceInfoId/:loggedHourId', name: 'EditLoggedCommunityServiceHours', props: true, component: EditLoggedCommunityServiceHours},

            {path:'addcertification', component: AddCertification, props: true },
            {path:'editcertification/:id', name:'EditCertification', component: EditCertification, props: true },
          ]

        },
        {path:'evaluations', component: EvaluationsMain, props: true,
          children: [
            {path:'', component: Evaluations, props: true},
            {path:'addevaluationwriter', component: AddEvaluationWriter, props: true },
            {path:'editevaluationwriter/:id', name: 'EditEvaluationWriter', props: true, component: EditEvaluationWriter},
            {path:'evaluationwriterinfo/:id', name: 'WriterInfo', props: true, component: WriterInfo},
          ]
        },
        {path:'exams', component: ExamsMain, props: true,
        children: [
          {path:'', component: Exams, props: true},
          {path:'addexam', component: AddExam, props: true},
          {path:'examinfo/:id', name: 'ExamInfo', props: true, component: ExamInfo},
          {path:'addexamscores/:id', name: 'AddExamScores', props: true, component: AddExamScores},
          {path:'editexamscores/:id', name: 'EditExam', props: true, component: EditExam},
        ]
      },
      ]
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/myaccount',
      name: 'Account',
      component: Account
    },
    {
      path: '/userquestions',
      name: 'UserProfileQuestions',
      component: UserProfileQuestions
    },
    {
      path: '/LoginSignupPage',
      name: 'LoginSignupPage',
      component: LoginSignupPage
    },
    {
      path: '/subscriptions',
      name: 'Subscriptions',
      component: Subscriptions
    },
    {
      path: '/services',
      name: 'Services',
      component: ServicesBase,
      children: [
        {
          path: "",
          component: Services
        },
        {
          path: 'purchase',
          name: "ServicePurchase",
          component: ServicesPurchase
        },
        {
          path: ':id',
          name: 'ServicesDetail',
          component: ServiceDetails
        },
        {
          path: "*",
          redirect: '/services'
        }
      ]
    },
    {
      path: '/payments/success',
      name: "ServicePurchaseSuccess",
      component: ServicesPurchaseSuccess
    },
    {
      path: '/payments/cancel',
      name: "ServicePurchaseCancel",
      component: ServicesPurchaseCancel
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'history'
})


// <!-- School Details -->
// <v-toolbar flat class="white elevation-7" fixed extended extension-height="190px">
//   <v-btn icon @click="close">
//     <v-icon color="blue" >arrow_back</v-icon>
//   </v-btn>
//     <v-layout align-center column wrap slot="extension" class="mt-1 mb-5 pb-3">
//       <img class="mb-1" :src="school.program_image" alt="">
//       <v-layout   row >
//         <p  class="schoolName mb-0 text-xs-center">{{school.school_name}}</p>
//       </v-layout>

//       <!-- Icon Row  -->
//       <v-layout row class="iconRow pt-0 mt-2 mb-3" >
//         <v-btn fab small color="grey darken-2" dark outline >
//           <v-icon >location_on</v-icon>
//         </v-btn>
//         <a :href="`tel:${school.program_phone_number}`">
//         <v-btn  fab small color="grey darken-2" dark outline>
//           <v-icon  >phone</v-icon>
//         </v-btn>
//         </a>
//         <a :href="`mailto:${school.program_email}`">
//         <v-btn fab small color="grey darken-2" dark outline>
//           <v-icon  >mail</v-icon>
//         </v-btn>
//         </a>

//       </v-layout>
//       <v-tabs
//         id="tabs"
//         slot="extension"
//         color="white"
//         slider-color="blue"

//       >
//       <span id="tabsContainer">
//         <!-- Saved Schools -->
//         <v-tab class="mt-2" :ripple="false"  href="#info">
//           Info

//         </v-tab>
//         <v-tab class="mt-2" :ripple="false" href="#requirements">
//           Requirements

//         </v-tab>

//         <v-tab class="mt-2" :ripple="false" href="#application">
//           Application

//         </v-tab>

//         <v-tab class="mt-2" :ripple="false" href="#prePaClub">
//           Pre-PA Club

//         </v-tab>
//       </span>

//     <!-- Program Info Content -->
//     <v-tab-item class="tabContent" id="info" >
//         <ProgramInfo :school="school"/>
//     </v-tab-item>

//     <!-- Program Requirement Content -->
//     <v-tab-item class="tabContent" id="requirements" >
//         <AdmissionRequirements :school="school"/>
//     </v-tab-item>

//     <!-- Application Content -->
//     <v-tab-item class="tabContent" id="application" >
//          <Application :school="school"/>
//     </v-tab-item>

//     <!-- Pre PA Club Content -->
//     <v-tab-item class="tabContent" id="prePaClub" >
//         <PrePaClub :school="school"/>
//     </v-tab-item>

//     </v-tabs>
//     </v-layout>

//   <v-spacer></v-spacer>

//   <v-btn  v-if="schoolAlreadySaved" round small color="blue"   :ripple="false" dark >
//     <v-icon  color="white" small class="mr-1" >bookmark</v-icon> Saved
//   </v-btn>
//   <v-btn  v-else @click="saveSchool()" round small color="blue"  outline :ripple="false" dark >
//     <v-icon  color="blue" small class="mr-1" >bookmark</v-icon> Save
//   </v-btn>


// </v-toolbar>



// WEBPACK FOOTER //
// ./src/router/index.js